export default __webpack_public_path__ + "static/assets/med_x_spray_nasal.227b771c.png";